// Builds the share URL + auto share text for a job (works for live + paid jobs).
export function jobSalaryText(job) {
  if (job.salary) return job.salary;
  const cur = job.salary_currency || "USD";
  const sym = cur === "USD" ? "$" : cur === "GBP" ? "£" : cur === "EUR" ? "€" : "";
  const min = Number(job.salary_min) || null;
  const max = Number(job.salary_max) || null;
  const fmt = (n) => `${sym}${Math.round(n).toLocaleString()}`;
  if (min && max) return `${fmt(min)} – ${fmt(max)}`;
  if (min) return `From ${fmt(min)}`;
  if (max) return `Up to ${fmt(max)}`;
  return "Competitive salary";
}

export function jobShareText(job) {
  const company = job.company || job.company_name || "a leading company";
  const location = job.location || job.country || ((job.is_remote ?? job.remote) ? "Remote" : "Global");
  return `${job.title} at ${company} — ${location} — ${jobSalaryText(job)} — Apply on WorldAIInfo.com`;
}

export function jobShareUrl(job, origin) {
  let base = origin || (typeof window !== "undefined" ? window.location.origin : "");
  try {
    const u = new URL(base);
    if (u.hostname === "worldaiinfo.com") { u.hostname = "www.worldaiinfo.com"; base = u.origin; }
  } catch (e) { /* keep */ }
  return `${base}/jobs/${job.id}`;
}
